<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 83 83"
    :height="height"
    :width="width"
  >
    <g transform="translate(1, 1)">
      <g fill-rule="evenodd" fill="none" stroke-width="1" stroke="none" id="Page-1_1599066777351">
        <g
          :fill="iconColor"
          transform="translate(-308.000000, -370.000000)"
          id="social-media-vector-icon_1599066777351"
        >
          <g transform="translate(308.122000, 370.574000)" id="Google_1599066777351">
            <path
              id="Combined-Shape_1599066777351"
              d="M40.206,8.52651283e-14 C62.411,8.52651283e-14 80.412,18.001 80.412,40.206 C80.412,62.412 62.411,80.412 40.206,80.412 C18.001,80.412 1.70530257e-13,62.412 1.70530257e-13,40.206 C1.70530257e-13,18.001 18.001,8.52651283e-14 40.206,8.52651283e-14 Z M30.918,23.952 C21.932,23.952 14.664,31.22 14.664,40.206 C14.664,49.192 21.932,56.46 30.918,56.46 C40.299,56.46 46.522,49.866 46.522,40.578 C46.522,39.509 46.406,38.697 46.267,37.884 L46.267,37.884 L30.918,37.884 L30.918,43.457 L40.137,43.457 L40.1146711,43.5896412 C39.6758539,46.0154727 37.2330545,50.469 30.918,50.469 C25.368,50.469 20.841,45.872 20.841,40.206 C20.841,34.54 25.368,29.943 30.918,29.943 C34.076,29.943 36.189,31.29 37.396,32.45 L37.396,32.45 L41.808,28.201 L41.5220143,27.939804 C38.7306,25.44898 35.1607,23.952 30.918,23.952 Z M61.104,33.24 L56.46,33.24 L56.46,37.884 L51.816,37.884 L51.816,42.528 L56.46,42.528 L56.46,47.172 L61.104,47.172 L61.104,42.528 L65.748,42.528 L65.748,37.884 L61.104,37.884 L61.104,33.24 Z"
              vector-effect="non-scaling-stroke"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "googleIcon",
  props: ["height", "width", "iconColor"],
};
</script>

<style scoped></style>
